import { BaseService } from './base.service'
import { ErrorWrapper, ResponseWrapper } from './util'

import storeHelper from '@/store/helper'
import axios from 'axios'

export class SalesManagerService extends BaseService {
  static async getGroupService(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.get-package-config')
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getGroupServicePaper(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/cfg/get-package-config`,
        {},
        {
          headers: {
            Authorization: params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDetailSalesManager(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.detail-by-code'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async assignSaleHistory(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.assign-sale-history'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async editUsername(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.appendix.fix-username'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvedContract(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.sa-approved'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectContract(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.sa-cancel'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectSAContractMpos(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.e_scon.sa-reject-contract-mpos'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectSAContract(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.sa-rejected'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async rejectContractQLBH(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.sa-cancel'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvedAppendixWithContract(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.ma-approved-fee'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async approvedApendixFee(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.ma-approved-fee'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getList(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.list-contract-on-web'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getListContract(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.get-list'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async uploadPdf(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.cfg.file-upload'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async saveLinkPFD(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.common.save-econtract-approved-by-pdf-file'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async getDataTablePLPM(params) {
    try {
      const response = await axios.post(
        `${window._env_?.VUE_APP_GET_CCRP_CONFIG ?? process.env.VUE_APP_GET_CCRP_CONFIG}/cfg/package-price-contract-list`,
        { serviceType: params.serviceType },
        {
          headers: {
            Authorization: 'Bearer ' + params.token,
          },
        }
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      const message = error.response.data ? error.response.data.error : error.response.statusText
      throw new ErrorWrapper(error, message)
    }
  }

  static async updateReqCheck(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.update-req-check'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async detailUpdateCus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.detail-update-cus'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async approveUpdateCus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.approve-update-cus'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async rejectUpdateCus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.reject-update-cus'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async historyUpdateCus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.list-history-update-cus'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async detailHistoryUpdateCus(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.cus-update-history-detail'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async updateReqRemove(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.update-req-remove'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async reCreateReceipt(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.receipt.re-create-receipt'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }

  static async activeMerchant(params) {
    try {
      const response = await this.request({ auth: true }).post(
        storeHelper.getUrl('cnps.scon.contract.active-state'),
        params
      )
      return new ResponseWrapper(response, response.data.data)
    } catch (error) {
      return error.response
    }
  }
}
